import { DoubleSlider } from './DoubleSlider';

export { DoubleSlider };
